import { FieldArray, FieldArrayRenderProps, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';

import { withDefaultStyles } from '../utils/material-ui/hoc';

class Consent extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        session: this.props.authentication.id,
                        apiHost: this.props.authentication.apiHost,
                        projectIds: this.props.app.consentedProjects,
                    }}
                    onSubmit={this.props.onLogin}
                    render={this.form}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <form
        method='post'
        action={this.props.actionUrl}>
        <DialogTitle id="alert-dialog-title">
            <Typography variant='inherit'>Consent Required</Typography>
        </DialogTitle>
        <DialogContent id="alert-dialog-description">
            <FormControl component="fieldset">
                <Input
                    required={true}
                    type="hidden"
                    name="token"
                    value={p.values.session} />
                <Input
                    required={true}
                    type="hidden"
                    name="apiHost"
                    value={p.values.apiHost} />
                <FormLabel component="legend">Do you allow PNS to access your Flybits data via a Service Account for these tenants</FormLabel>
                <FormGroup>
                    <FieldArray name="projectIds" render={arrayHelpers =>
                        /* tslint:disable:jsx-no-lambda */
                        this.checkboxes(arrayHelpers, p.values)} />
                </FormGroup>
                <FormHelperText>Grant can be revoked by revisiting this page.</FormHelperText>
            </FormControl>
        </DialogContent>

        <DialogActions>
            <Button type="submit" color="primary" disabled={p.isSubmitting}>Accept</Button>
        </DialogActions>
    </form>

    private checkboxes = (arrayHelpers: FieldArrayRenderProps, values: any) => this.props.app.projects.map(project => (
        <FormControlLabel key={project.id}
            control={
                <Checkbox value={project.id}
                    name="projects"
                    key={project.id}
                    checked={values.projectIds.includes(project.id)}
                    onChange={e => {
                        if (e.target.checked) {
                            arrayHelpers.push(project.id)
                        } else {
                          const idx = values.projectIds.indexOf(project.id);
                          arrayHelpers.remove(idx);
                        }
                    }}
                />}
            label={`${project.Name} - ${project.Subdomain}`}
        />
    ))
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(Consent));



// WEBPACK FOOTER //
// ./src/components/consent-form.tsx